import styled from "styled-components";
import { gray, red } from "../../../utils/styles";
import { hexToRgba } from "../../../utils/helpers";

const SelectInputStyles = styled.div`
  .input__mock {
    height: 44px;
    background: ${gray(100)};
    border: 1px solid ${gray(200)};
    border-radius: 4px;
    cursor: pointer;
    display: flex;
    align-items: center;
    padding: 0 10px;
    font-size: 14px;
  }
  .input__mock--placeholder {
    color: ${gray(400)};
  }

  .input__mock.error,
  .input__mock.error:focus,
  .input__mock.error:focus-visible {
    border: 2px solid ${red()};
  }
  label {
    font-weight: bold;
    margin-bottom: 4px;
    font-size: 16px;
  }
  label .required-asterisk {
    color: ${red()};
  }
  .label-container {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
  }
  .helper-text {
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    font-style: italic;
    color: #6a6a6a;
  }
  .input__mock.focus {
    border: 2px solid
      ${(props) => (props.$primary_color ? props.$primary_color : gray(200))};
    background: #fff;
    outline: none;
  }
  .input__mock.hasValue {
    background: #fff;
  }
  .input-container {
    margin-bottom: 15px;
  }
  .input-error {
    font-size: 12px;
    font-weight: bold;
    color: ${red()};
  }
  .options__container {
    position: relative;
  }
  .options {
    border: 1px solid #aaa;
    border-radius: 0 0 4px 4px;
    z-index: 1;
    max-height: 150px;
    overflow-y: scroll;
    position: absolute;
    background: #fff;
    width: 100%;
    display: block;
    box-shadow:
      0px 1px 3px rgba(0, 0, 0, 0.3),
      0px 4px 8px 3px rgba(0, 0, 0, 0.15);
  }
  .options__item {
    margin-bottom: 8px;
    font-size: 16px;
    cursor: pointer;
    padding: 8px;
  }
  .options__item:hover {
    background: ${(props) =>
      props.$primary_color ? hexToRgba(props.$primary_color, ".2") : "#e0e0e0"};
  }
  .input__container {
    position: relative;
    cursor: pointer;
  }
  .input__arrow {
    position: absolute;
    top: 0;
    right: 4px;
    height: 44px;
    display: flex;
    align-items: center;
    max-width: fit-content;
  }
  .required-asterisk {
    color: ${red()};
  }
`;
export default SelectInputStyles;
